import { hashKey } from "@tanstack/react-query";
import { DataTieringRepositories } from "@graylog/enterprise-api";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
import { REPOSITORIES_QUERY_KEY } from "../constants";
export const keyFn = (searchParams) => [REPOSITORIES_QUERY_KEY, "paginated", searchParams];
let lastFetchedParamsHash = null;
const isBackgroundRefresh = (searchParams) => {
  const paramsHash = hashKey(keyFn(searchParams));
  const isRepeatedFetch = paramsHash === lastFetchedParamsHash;
  lastFetchedParamsHash = paramsHash;
  return isRepeatedFetch;
};
const fetchPaginatedRepositories = async (searchParams) => {
  var _a;
  const response = await DataTieringRepositories.pageListRepositories(
    searchParams.page,
    searchParams.pageSize,
    searchParams.query,
    FiltersForQueryParams(searchParams.filters),
    searchParams.sort.attributeId,
    searchParams.sort.direction,
    { requestShouldExtendSession: !isBackgroundRefresh(searchParams) }
  );
  const outstandingChecks = (_a = response.outstanding_checks) != null ? _a : 0;
  return {
    list: response.elements.map((element) => ({ ...element, id: element.name })),
    pagination: { total: response.total },
    attributes: response.attributes,
    meta: { outstandingChecks }
  };
};
export default fetchPaginatedRepositories;
